<template>
    <div class="template-generator-spacer"></div>
</template>

<script>
export default {}
</script>
